// Copyright © 2021 Move Closer
/**
 * @author Jan Dobrowolski <jan.dobrowolski@movecloser.pl>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var AudioType;
(function (AudioType) {
    AudioType["MP3"] = "mp3";
})(AudioType || (AudioType = {}));
/**
 * @author Jan Dobrowolski <jan.dobrowolski@movecloser.pl>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var DocumentType;
(function (DocumentType) {
    DocumentType["CSV"] = "csv";
    DocumentType["DOC"] = "doc";
    DocumentType["DOCX"] = "docx";
    DocumentType["PDF"] = "pdf";
    DocumentType["XLS"] = "xls";
})(DocumentType || (DocumentType = {}));
/**
 * @author Jan Dobrowolski <jan.dobrowolski@movecloser.pl>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var ImageType;
(function (ImageType) {
    ImageType["GIF"] = "gif";
    ImageType["JPEG"] = "jpeg";
    ImageType["JPG"] = "jpg";
    ImageType["PNG"] = "png";
    ImageType["SVG"] = "svg";
})(ImageType || (ImageType = {}));
/**
 * @author Jan Dobrowolski <jan.dobrowolski@movecloser.pl>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var VideoType;
(function (VideoType) {
    VideoType["MOV"] = "mov";
    VideoType["MP4"] = "mp4";
    VideoType["MPEG"] = "mpeg";
})(VideoType || (VideoType = {}));
